import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { useBilling } from '@/components/Billing/Billing.composables';
// @ts-ignore
import BillingPlanCardHeaderUserTypePriceBox from '@/components/Billing/BillingPlanCardHeaderUserTypePriceBox.vue';
import BillingService from '@/components/Billing/billing-service';
import { Plan, ProductType } from '@/components/Billing/billing-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingPlanCardHeader',
  props: {
    plan: null,
    isSelected: { type: Boolean },
    isVirtuallyUnlimited: { type: Boolean },
    selectedCustomerFeatureTasksAmount: null
  },
  setup(__props: any) {

const props = __props as {
	plan: Plan;
	isSelected: boolean;
	isVirtuallyUnlimited?: boolean;
	selectedCustomerFeatureTasksAmount?: number;
}


const { isAnnuallyPlan, useProduct, billingPeriod } = useBilling();
const isPaidPlan = computed(() => BillingService.isPaidPlan(props.plan));
const isFreePlan = computed(() => BillingService.isFreePlan(props.plan));
const isCustomPlan = computed(() => BillingService.isCustomPlan(props.plan));
const isTeamFeaturesPlan = computed(() => BillingService.isTeamFeaturesPlan(props.plan));
const planDisplayName = computed(() => {
	if (isCustomPlan.value) {
		return 'Contact us';
	}
	return 'Free';
});

const getMonthlyPrice = (price: number) => (isAnnuallyPlan.value ? price / 12 : price);

const prices = computed(() => {
	if (isPaidPlan.value) {
		if (isTeamFeaturesPlan.value) {
			const prices = BillingService.getUsersPrice(
				useProduct.value(ProductType.TeamFeatures),
				props.plan,
				billingPeriod.value,
				props.isVirtuallyUnlimited || false
			);
			return [
				{ price: prices[0], description: 'Per standard member' },
				{ price: prices[1], description: 'Per premium member' },
			];
		}
		const price = BillingService.getCustomerFeaturesPrice(
			useProduct.value(ProductType.CustomerFeatures),
			BillingService.getPlanGroup(props.plan),
			billingPeriod.value,
			props.selectedCustomerFeatureTasksAmount || 0
		);
		return [{ price }];
	}
	return [];
});

return { __sfc: true,props, isAnnuallyPlan, useProduct, billingPeriod, isPaidPlan, isFreePlan, isCustomPlan, isTeamFeaturesPlan, planDisplayName, getMonthlyPrice, prices, BillingPlanCardHeaderUserTypePriceBox }
}

})